function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#47545e",
  d: "M8.772 1.04a.4.4 0 0 0-.572 0 .404.404 0 0 0 0 .566l2.9 2.9H1.53c-.223 0-.4.178-.4.4 0 .224.177.407.4.407h9.57L8.2 8.207a.41.41 0 0 0 0 .572.4.4 0 0 0 .572 0l3.586-3.586a.394.394 0 0 0 0-.566z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#47545e",
  strokeMiterlimit: 20,
  d: "M8.772 1.04a.4.4 0 0 0-.572 0 .404.404 0 0 0 0 .566l2.9 2.9v0H1.53c-.223 0-.4.178-.4.4 0 .224.177.407.4.407h9.57v0L8.2 8.207a.41.41 0 0 0 0 .572.4.4 0 0 0 .572 0l3.586-3.586a.394.394 0 0 0 0-.566z"
})));

var SvgViewArrowBlack = function SvgViewArrowBlack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgViewArrowBlack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/viewArrow-black.d336f35c.svg";
export { ForwardRef as ReactComponent };